module.exports = {
	"base": {
		"welcome": "欢迎使用 Mulligans，%{name}！",
		"user": "用户信息",
		"devices": "设备",
		"refunds": "退款",
		"resources": "资源",
		"transactions": "订单与退货",
		"email": "电子邮件",
		"password": "密码",
		"save": "保存",
		"sign-out": "注销",
		"cancel": "取消",
		"close": "关闭",
		"learn-more": "了解更多",
		"required": "必填",
		"support": "支持",
		"bookshelf": "书架",
		"launch": "启动",
		"download": "下载",
		"details": "详细信息",
		"cannot-be-blank": "%{field} 不能为空",
		"saving": "正在保存…",
		"done": "已完成",
		"failed": "失败",
		"copy": "复制"
	},
	"signin": {
		"login-failure": "电子邮件或密码不正确",
		"welcome-large": "欢迎进入 <span class='inner'>%{brand} 帐户中心</span>",
		"welcome-small": "<span class='inner'>帐户中心</span>",
		"signin-button": "登录",
		"forgot-password": "忘记您的密码了",
		"new-to-vst": "%{brand} 新手？",
		"create-account": "创建帐户",
		"signing-in": "正在登录...",
		"signin-failed": "登录失败"
	},
	"transactions": {
		"price": "价格",
		"excluded": "（不含税）",
		"quantity": "数量",
		"confirmation#": "确认 #",
		"payment": "付款",
		"purchased": "已购买",
		"purchase-details": "购买详细信息",
		"subtotal": "小计",
		"total": "合计",
		"tax": "税金",
		"loading": "嘿！超级大买家，我们正在加载您的交易...",
		"no-purchases": "您并无购买。",
		"seller-vat": "卖家增值税",
		"total-vat": "所付%{vat}合计",
		"portion": "%{subTax} 税 %{rate}%",
		"vat-disclosure": "价格包含 %{vat}",
		"purchases": "购买",
		"refunded-items": "退款项目",
		"book-title": "图书标题",
		"refund-details": "退款详细信息",
		"print-receipt": "打印收据",
		"request-refund": "请求退款",
		"expired": "已过期",
		"expires-in": "过期日：%{date}",
		"details-refund": "详情与退款",
		"modal": {
			"cant-refund-title": "退款不可用",
			"cant-refund": "出于下列一项或多项原因，您的图书不可退款。",
			"cant-refund-1": "您的大量图书已被看过。",
			"cant-refund-2": "自购买之日起已超过 14 日。",
			"cant-refund-3": "您的在线资源代码已被泄露。",
			"cant-refund-4": "您的图书之前已经退款。",
			"cant-refund-5": "所有代码已兑换和/或退款。",
			"cant-refund-6": "自购买之日起已超过 30 日。",
			"cant-refund-support": "如果您仍对 %{brand} 的退款政策不确定，请联系<a href='%{support_url}' target='_blank'>支持部门</a>。"
		},
		"license": {
			"perpetual": "在线访问权限不会过期",
			"days": "%{days} 天访问权限"
		}
	},
	"devices": {
		"description": "%{brand} 让您能够在任何给定时间激活 <span>%{desktop} </span>计算机和 <span>%{mobile} </span>移动/平板设备。",
		"loading": "嘿，我们找到您的设备了 :)",
		"no-active": "您并无活动设备。",
		"deactivate": "停用"
	},
	"user": {
		"personal-information": "个人信息",
		"security-information": "安全信息",
		"notifications": "通知",
		"first-name": "名字",
		"last-name": "姓氏",
		"change-password-title": "更改密码",
		"current-password": "当前密码",
		"new-password": "新密码",
		"security-password": "密码",
		"confirm-new-password": "确认新密码",
		"security-question": "安全问题",
		"security-info-change": "更改",
		"question": "问题",
		"answer": "答案",
		"notifications-text": "请将有关我的账户活动、产品更新及特别优惠的更新信息通过电子邮件发送给我。",
		"loading": "Spot 正在提取您的用户信息，稍等 🐶",
		"change-password-text": "密码必须包含至少 8 个字符、一个大写字母、一个小写字母和一个特殊字符。",
		"email-locked": "电子邮箱已锁定",
		"email-locked-description": "您没有权限更改您的电子邮箱。",
		"email-locked-more": "请联系您的管理员。",
		"security-question6": "您最喜爱的运动是什么?",
		"security-question7": "您最喜爱的冰淇淋口味是什么?",
		"security-question8": "您最喜爱的宠物叫什么名字?",
		"security-question9": "在您年轻的时候，想过长大后想当什么吗？",
		"security-question10": "您最喜爱的老师姓什么?",
		"new-password-failure": "密码不符合要求",
		"confirm-password-failure": "密码必须匹配",
		"new-password-tooltip": "必须包含至少 8 个字符、一个大写字母、一个小写字母和一个特殊字符。",
		"enter-valid-email": "请输入有效的电子邮件。",
		"password-cannot-be-same": "密码不能与以前的密码相同",
		"incorrect-password": "密码不正确",
		"complete-account": "您可能需要<a href='%{href}'>完善您的帐户</a>。",
		"completing-allows": "完善您的帐户后可在移动应用程序中离线阅读图书，以及与朋友分享注释和热点标注。",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "附件",
		"access-codes": "访问代码",
		"print-on-demand": "按需打印",
		"check-pod": "为您的图书勾选出版商打印选项。",
		"check-now": "立刻查看",
		"loading": "请紧记，我们正在更新您的资源！",
		"in": "于",
		"access-code-intro": "访问代码是用于在线访问课程内容的密码。一旦泄露某个项目的代码，则无法将其退还。有关如何使用访问代码的更多说明，请访问<a href='%{support_url}' target='_blank'>支持</a>页面。",
		"expires": "过期",
		"expiration-message": "包含使用访问代码的说明。",
		"copy-fail": "无法复制。请选择代码并手动复制。",
		"launch-site": "启动网站",
		"launch-book": "启动图书",
		"reveal-code": "显示代码",
		"no-resources": "您并无任何资源。",
		"no-access-codes": "您并无任何访问代码。",
		"no-ancillaries": "此标题并无任何附件",
		"name": "名称",
		"type": "类型",
		"size": "大小",
		"download-all": "下载全部",
		"back": "回到资源"
	},
	"refunds": {
		"states": {
			"refunded": "已退款",
			"unavailable": "退款不可用"
		},
		"reasons": {
			"dropped": "我放弃了课程",
			"wrong": "这不是对应我课程的图书",
			"print": "我决定改为买印刷版",
			"missing": "此图书并未包含我的课程所需的一切（如 CD、网络访问权限、视频）",
			"other": "其他"
		},
		"bulk": {
			"policy": "单击下方的“完成退款”按钮，即表示我同意 %{brand} 的<a href='%{policy_url}' target='_blank'>退款政策</a>。",
			"complete": "完成退款",
			"view-details": "查看退款详细信息",
			"success": "您已申请退款。请等待 48 小时进行处理。",
			"failure": "糟糕 - 发生错误了！很抱歉，您的退款没有通过。",
			"retry": "重试",
			"support": "联系支持",
			"available-codes": "可用代码",
			"codes-selected": "已选代码",
			"download": "下载代码",
			"partially-refunded": "已部分退款",
			"pick-one": "您必须至少选择一个代码，以便退款"
		},
		"refund": "退款",
		"all": "全部退款？",
		"missing-reason": "必须选择一个理由才能继续",
		"missing-elaboration": "请详细说明",
		"policy": "单击下面的“完成退款申请”按钮，即表示我理解，如果我再次购买此 %{brand} eTextbook，则将不具备资格就同一 eTextbook 再次申请退款。查看完整退款政策。",
		"refunded": "已退款",
		"sorry": "很遗憾您对此次购买并不满意。",
		"error": "发生错误",
		"error-explain": "我们无法处理您的退款。请稍后重试。",
		"why": "请告诉我们原因",
		"no-refunds": "您并无退款项目。",
		"select-codes": "选择退款的代码：",
		"number": "多少？",
		"back": "回到退款"
	},
	"purchases": {
		"back": "回到购买"
	},
	"global-bar": {
		"account": "帐户设置"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/zh-CN.json
 ** module id = 1027
 ** module chunks = 0
 **/